<template>
  <div class="provider-editor">
    <div class="row">
      <div class="col logo-container">
        <label class="label">โลโก้</label>
        <img class="thumbnail" :src="thumbnailUrl" />
        <sc-button
          class="thumbnail-button"
          v-if="!disabled"
          @click="handleClickChooseLogoButton"
          >เลือกรูปโลโก้</sc-button
        >
      </div>
      <div class="col">
        <label class="label">ชื่อ (ที่ใช้บน SAP)
          <div class="warnning-text">
            ({{ nameOnSapLength }}/70ตัวอักษร)
          </div>
        </label>
        <el-input
          class="input"
          :disabled="disabled"
          :value="value.nameOnSap"
          :maxlength="70"
          @input="handleChange('nameOnSap', $event)"
        ></el-input>
        <label class="label">ชื่อ (ที่ใช้บน App)</label>
        <el-input
          class="input"
          :disabled="disabled"
          :value="name"
          @input="handleChange('name', $event)"
        ></el-input>
        <div class="row">
          <div class="col-3">
            <label class="label"
              >TAX ID.
              <div class="warnning-text">
                ({{ taxIdLength }}/13ตัวอักษร)
              </div></label
            >
            <div v-if="value.taxId === null">
              <el-input
                class="input"
                :disabled="disabled"
                :value="value.taxId"
                :maxlength="13"
                @input="handleChange('taxId', $event)"
              ></el-input>
            </div>
            <div v-else>
              <button
                v-if="!isButtonHidden"
                class="button-content"
                @click="handleDecryptTaxId"
              >
                <span style="font-weight: bold">แสดงข้อมูล</span>
                <i class="fa fa-eye-slash" aria-hidden="true"></i>
              </button>

              <div v-if="value.taxId" class="identifier-id">
                <el-input
                  class="input"
                  :disabled="disabled"
                  :value="value.taxId"
                  :maxlength="13"
                  @input="handleChange('taxId', $event)"
                ></el-input>
              </div>
            </div>
          </div>
          <div class="col-3">
            <label class="label">ประเภทบุคคล</label>
            <el-select
              :value="value.providerType"
              @input="handleChange('providerType', $event)"
              style="width: 100%"
            >
              <el-option
                v-for="t in providerTypeDropdown"
                :key="t.value"
                :label="t.label"
                :value="t.value"
              ></el-option>
            </el-select>
          </div>
        </div>

        <div class="row">
          <div class="col-3">
            <label class="label">บ้านเลขที่
              <div class="warnning-text">
                ({{ houseNoLength }}/10ตัวอักษร)
              </div>
            </label>
            <el-input
              class="input"
              :disabled="disabled || isDisable"
              :value="value.houseNo"
              @input="handleChange('houseNo', $event)"
              :maxlength="10"
            ></el-input>
          </div>
          <div class="col-9">
            <label class="label">ที่อยู่ (หมู่บ้าน , ซอย , ถนน)
              <div class="warnning-text">
                ({{ streetAddressLength }}/90ตัวอักษร)
              </div>
            </label>
            <el-input
              class="input"
              :disabled="disabled || isDisable"
              :value="value.streetAddress"
              @input="handleChange('streetAddress', $event)"
              :maxlength="90"
            ></el-input>
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <label class="label">รหัสไปรษณีย์</label>
            <el-select
              :value="value.addressForm.zipCode"
              class="input"
              @input="handleChangeAddressForm('zipCode', $event)"
              type="number"
              :disabled="disabled || isDisable"
              clearable
              :filterable="!zipCodeDropdown || (zipCodeDropdown && zipCodeDropdown.length !== 1)"
              remote
              :remote-method="handleSearchZipCode"
              style="width: 100%"
            >
              <el-option
                v-for="(p, index) in zipCodeDropdown"
                :value="p.zip_code"
                :label="p.zip_code"
                :key="index"
                >{{ p.zip_code }}</el-option
              >
            </el-select>
          </div>
          <div class="col-3">
            <label class="label">จังหวัด</label>
            <el-select
              :value="value.addressForm.province"
              @input="handleChangeAddressForm('province', $event)"
              class="input"
              value-key="province_code"
              :disabled="disabled || isDisable"
              label-key="province_name"
              style="width: 100%"
            >
              <el-option
                v-for="p in provinceDropdown"
                :value="p.province_name"
                :label="p.province_name"
                :key="p.province_name"
                >{{ p.province_name }}</el-option
              >
            </el-select>
          </div>
          <div class="col-3">
            <label class="label">เขต / อำเภอ</label>
            <el-select
              :value="value.addressForm.amphurName"
              @input="handleChangeAddressForm('amphurName', $event)"
              class="input"
              filterable
              value-key="amphur_code"
              label-key="amphur_name"
              :disabled="disabled || isDisable"
              style="width: 100%"
            >
              <el-option
                v-for="p in districtUniqueList"
                :value="p.amphur_name"
                :label="p.amphur_name"
                :key="p.amphur_code"
                >{{ p.amphur_name }}</el-option
              >
            </el-select>
          </div>
          <div class="col-3">
            <label class="label">แขวง / ตำบล</label>
            <el-select
              :value="value.addressForm.tumbonName"
              @input="handleChangeAddressForm('tumbonName', $event)"
              class="input"
              filterable
              value-key="amphur_code"
              label-key="amphur_name"
              :disabled="disabled || isDisable"
              style="width: 100%"
            >
              <el-option
                v-for="p in subDistrictUniqueList"
                :value="p.tumbon_name"
                :label="p.tumbon_name"
                :key="p.tumbon_code"
                >{{ p.tumbon_name }}</el-option
              >
            </el-select>
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <label class="label">เบอร์โทรศัพท์</label>
            <el-input
              class="input"
              :disabled="disabled || isDisable"
              type="number"
              :value="value.mobileNumber"
              @input="handleChange('mobileNumber', $event)"
            ></el-input>
          </div>
          <div class="col-3">
            <label class="label">จด Vat</label>
            <div>
              <label class="select-input">
                <span>จด</span>
                <input
                  type="radio"
                  :value="true"
                  name="type"
                  v-model="value.isVatRegistered"
                />
                <span class="checkmark radio"></span>
              </label>
              <label class="select-input">
                <span>ไม่จด</span>
                <input
                  type="radio"
                  :value="false"
                  name="type"
                  v-model="value.isVatRegistered"
                />
                <span class="checkmark radio"></span>
              </label>
            </div>
          </div>
        </div>
        <label class="label">หมายเหตุ</label>
        <el-input
          :disabled="disabled"
          :value="remark"
          @input="handleChange('remark', $event)"
          type="textarea"
          rows="7"
        ></el-input>
      </div>
    </div>
    <image-picker-modal
      v-bind="chooseLogoDialog"
      @cancel="handleCancelChooseLogoDialog"
      @confirm="handleConfirmChooseLogoDialog"
    ></image-picker-modal>
  </div>
</template>

<script>
import { Input, Select, Option } from "element-ui";
import ScButton from "@/lib/components/ScButton";
import ImagePickerModal from "@/lib/components/ImagePickerModal";
import { baanRueJaiClient } from "@/dependencies";
import { backendAdminClient } from "@/dependencies";

export default {
  props: ["value", "logoUrl", "disabled", "isDisable"],
  components: {
    ScButton,
    ImagePickerModal,
    "el-input": Input,
    "el-select": Select,
    "el-option": Option,
  },
  data() {
    const providerTypeDropdown = [
      { label: "บุคคลธรรมดา", value: "INDIVIDUAL" },
      { label: "นิติบุคคล", value: "CORPORATE" },
    ];

    return {
      isShowModal: false,
      providerTypeDropdown,
      addressSearchByZipCode: null,
      zipCodeDropdown: null,
      provinceUniqueList: null,
      districtUniqueList: null,
      subDistrictUniqueList: null,
      decryptedId: null,
      isButtonHidden: false,
    };
  },
  computed: {
    name() {
      return this.value.name;
    },
    remark() {
      return this.value.remark;
    },
    thumbnailUrl() {
      if (!this.chooseLogoDialog.thumbnailUrl) {
        return "https://placehold.co/300";
      }

      return this.chooseLogoDialog.thumbnailUrl;
    },
    chooseLogoDialog() {
      return {
        isShow: this.isShowModal,
        isLoading: false,
        canEdit: !this.disabled,
        title: "เลือกรูปโลโก้ผู้ให้บริการ",
        width: 200,
        height: 200,
        recommendWidth: 200,
        recommendHeight: 200,
        thumbnailFile: this.value.logoFile,
        thumbnailUrl: this.logoUrl,
      };
    },
    provinceDropdown() {
      return this.provinceUniqueList;
    },
    districtDropdown() {
      return this.districtUniqueList;
    },
    taxIdLength() {
      return this.value && this.value.taxId
        ? this.value.taxId.length
        : 0;
    },
    houseNoLength() {
      return this.value && this.value.houseNo
        ? this.value.houseNo.length
        : 0;
    },
    streetAddressLength() {
      return this.value && this.value.streetAddress
        ? this.value.streetAddress.length
        : 0
    },
    nameOnSapLength() {
      return this.value && this.value.nameOnSap
        ? this.value.nameOnSap.length
        : 0
    }
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue.addressForm.province !== oldValue.addressForm.province) {
        const districts = this.addressSearchByZipCode
          && newValue.addressForm.province
          ? this.addressSearchByZipCode.filter(
            (address) =>
              address.zip_code === this.value.addressForm.zipCode &&
              address.province_name === newValue.addressForm.province
          )
          : null;

        this.districtUniqueList = districts
          ? this.getUniqueListBy(districts, "amphur_name")
          : null;

        if (this.districtUniqueList && this.districtUniqueList.length === 1) {
          this.$emit("input", {
            ...this.value,
            addressForm: {
              ...this.value.addressForm,
              amphurName: this.districtUniqueList[0].amphur_name
            },
          });
        } else if (this.districtUniqueList) {
          this.$emit("input", {
            ...this.value,
            addressForm: {
              ...this.value.addressForm,
              tumbonName: null
            },
          });
        }
      }

      if (newValue.addressForm.amphurName !== oldValue.addressForm.amphurName) {
        const subDistricts = this.addressSearchByZipCode
          && newValue.addressForm.amphurName
          ? this.addressSearchByZipCode.filter(
            (address) =>
              address.zip_code === this.value.addressForm.zipCode &&
              address.province_name === newValue.addressForm.province &&
              address.amphur_name === newValue.addressForm.amphurName
          )
          : null;

        this.subDistrictUniqueList = subDistricts
          ? this.getUniqueListBy(subDistricts, "tumbon_name")
          : null;

        if (this.subDistrictUniqueList && this.subDistrictUniqueList.length === 1) {
          this.$emit("input", {
            ...this.value,
            addressForm: {
              ...this.value.addressForm,
              tumbonName: this.subDistrictUniqueList[0].tumbon_name
            },
          });
        } else if (this.subDistrictUniqueList) {
          this.$emit("input", {
            ...this.value,
            addressForm: {
              ...this.value.addressForm,
              tumbonName: null
            },
          });
        }
      }
    },
  },
  methods: {
    handleChange(key, value) {
      if (
        (key === "nameOnSap" && value.length > 70)
        || (key === "taxId" && value.length > 13)
        || (key === "houseNo" && value.length > 10)
        || (key === "streetAddress" && value.length > 90)
      ) {
        return;
      }

      this.$emit("input", { ...this.value, [key]: value });
    },
    handleClickChooseLogoButton() {
      this.showChooseLogoDialog();
    },
    handleCancelChooseLogoDialog() {
      this.hideChooseLogoDialog();
    },
    handleConfirmChooseLogoDialog(file) {
      this.$emit("input", { ...this.value, logoFile: file });
      this.hideChooseLogoDialog();
    },
    showChooseLogoDialog() {
      this.isShowModal = true;
    },
    hideChooseLogoDialog() {
      this.isShowModal = false;
    },
    async handleChangeAddressForm(key, value) {
      switch (key) {
        case "zipCode":
          this.$emit("input", {
            ...this.value,
            addressForm: {
              zipCode: null,
              province: null,
              amphurName: null,
              tumbonName: null
            },
          });

          await this.handleChangeAddressZipCodeForm(value);
          break;
        default:
          this.$emit("input", {
            ...this.value,
            addressForm: {
              ...this.value.addressForm,
              [key]: value,
            },
          });
          break;
      }
    },
    async handleChangeAddressZipCodeForm(val) {
      const provinces = this.addressSearchByZipCode
        ? this.addressSearchByZipCode.filter(
            (address) => address.zip_code === val
          )
        : null;

      this.provinceUniqueList = provinces
        ? this.getUniqueListBy(provinces, "province_name")
        : null;

      if (provinces) { this.zipCodeDropdown = this.provinceUniqueList }

      if (this.provinceUniqueList && this.provinceUniqueList.length === 1) {
        this.$emit("input", {
          ...this.value,
          addressForm: {
            ...this.value.addressForm,
            zipCode: val,
            province: this.provinceUniqueList[0].province_name
          },
        });
      } else {
        this.$emit("input", {
          ...this.value,
          addressForm: {
            zipCode: val,
            province: null,
            amphurName: null,
            tumbonName: null,
          },
        });
      }
    },
    async handleSearchZipCode(queryString) {
      const params = { zip_code: queryString };
      const response = await baanRueJaiClient.admin.addresses.list(params);
      this.addressSearchByZipCode = response.data.result;

      this.zipCodeDropdown = this.getUniqueListBy(
        this.addressSearchByZipCode,
        "zip_code"
      );
    },
    getUniqueListBy(array, key) {
      return [...new Map(array.map((item) => [item[key], item])).values()];
    },
    async handleDecryptTaxId() {
      const { id } = this.$route.params;
      try {
       const response = await backendAdminClient.provider.getDecryptedTaxId(id);
      
        this.value.taxId = response.data.result.tax_id;
        this.isButtonHidden = true;
      } catch (error) {
        alert("ไม่สามารถเข้าถึงได้");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.provider-editor {
  .thumbnail-button {
    display: block;
    width: 100%;
  }
}

.label {
  margin-bottom: 5px;
  display: block;

  line-height: 1.6;
  font-size: 1rem;
  font-weight: bold;
}

.input {
  margin-bottom: 20px;
}

.thumbnail {
  margin-bottom: 20px;

  border-radius: $border-radius;
  border: $border;
  width: 100%;
}

.logo-container {
  max-width: 180px;
}

.warnning-text {
  font-size: 13px;
  font-style: normal;
  color: #5c5b5b;
  display: inline;
}

.button-content {
  width: 200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  font-size: 16px;
  color: #4a4a4a;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  cursor: pointer;
  outline: none;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.2s ease;
}

.button-content:hover {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/providers/components/ProviderEditor.vue